import React from 'react';
import { Box, Flex, Text, useColorModeValue } from '@chakra-ui/react';
import { t } from 'i18next';

import { DateRangeType } from '../../../common/components/DateRangeTypePicker';
import { StatefulChart } from '../../../common/components/StatefulChart';
import { HISTORY_CHART_OPTIONS } from '../constants';
import { ChargingActivityData } from '../types';
import { useChargingHistoryChartData, useChargingHistorySeries } from './use-charging-history-chart-data';

type Props = {
  readonly isLoaded: boolean;
  readonly selectedDateRangeType: DateRangeType;
  readonly rangeTypeToSelectedPeriod: Record<DateRangeType, Date>;
  readonly data: ChargingActivityData;
  readonly onChartChange: (isCostViewSelected: boolean) => void;
  readonly isCostViewSelected: boolean;
};

export function HistoryChart({
  isLoaded,
  selectedDateRangeType,
  rangeTypeToSelectedPeriod,
  data,
  onChartChange,
  isCostViewSelected,
}: Props) {
  const { energyConsumedSeries } = useChargingHistorySeries(data, selectedDateRangeType, isCostViewSelected);
  const color = useColorModeValue('#1E79B6', '#42B4E6');
  const chartOpts = HISTORY_CHART_OPTIONS;

  const options = useChargingHistoryChartData({
    series: [...energyConsumedSeries],
    selectedDateRangeType,
    rangeTypeToSelectedPeriod,
    chartOpts,
    isCostViewSelected,
  });

  const isData = !!data.chargingSessions.length;

  return (
    <>
      {isData && (
        <Flex fontSize={12} flexDirection="row" mb={2} pt={3}>
          <Text fontWeight={600}>{t('Activity.chart view').toUpperCase()}:</Text>
          <Box onClick={() => onChartChange(true)} ml={2} data-testid="chart-view-cost-btn">
            <Text color={isCostViewSelected ? color : 'current'}>{t('Common.cost').toUpperCase()}</Text>
          </Box>

          <Text ml={2}>|</Text>
          <Box ml={2} onClick={() => onChartChange(false)} data-testid="chart-view-kw-btn">
            <Text color={!isCostViewSelected ? color : 'current'}>kW</Text>
          </Box>
        </Flex>
      )}
      <StatefulChart
        isLoaded={isLoaded}
        isData={isData}
        height={HISTORY_CHART_OPTIONS.height}
        options={options}
        testId={'charging-history-chart-container'}
      />
    </>
  );
}
